import * as React from 'react';
import {Tabs, Tab} from 'shared-portal-components-v2';

import type { ExternalInvitationTabKey } from '@/types/ExternalInvitationStep.types';
import { classNames } from '@/utils/classNames.utils';

export interface ExternalInvitationTabsProps {
  activeTab: ExternalInvitationTabKey;
  onTabChange: (nextTab: ExternalInvitationTabKey) => void;

  contactsTabId: string;
  manualTabId: string;
  contactsPanelId: string;
  manualPanelId: string;

  className?: string;
}

export function ExternalInvitationTabs(props: ExternalInvitationTabsProps): React.JSX.Element {
  const { activeTab, onTabChange, contactsTabId, manualTabId, contactsPanelId, manualPanelId, className } = props;

  const contactsTabIsActive = activeTab === 'contacts';
  const manualTabIsActive = activeTab === 'manual';

  return (
    <Tabs
      ariaLabel="External invitation mode"
      className={classNames(
        'grid w-full grid-cols-2',
        'h-10 items-center justify-center rounded-md bg-muted p-1 text-muted-foreground',
        'border-0',
        className
      )}
    >
      <Tab
        id={contactsTabId}
        aria-controls={contactsPanelId}
        label="From Contacts"
        isActive={contactsTabIsActive}
        onClick={() => {
          onTabChange('contacts');
        }}
        className={classNames(
          'justify-center rounded-sm px-3 py-1.5',
          'border-0 border-b-0',
          contactsTabIsActive ? 'bg-background text-foreground shadow-sm' : 'bg-muted'
        )}
      />

      <Tab
        id={manualTabId}
        aria-controls={manualPanelId}
        label="New Invitation"
        isActive={manualTabIsActive}
        onClick={() => {
          onTabChange('manual');
        }}
        className={classNames(
          'justify-center rounded-sm px-3 py-1.5',
          'border-0 border-b-0',
          manualTabIsActive ? 'bg-background text-foreground shadow-sm' : 'bg-muted'
        )}
      />
    </Tabs>
  );
}

ExternalInvitationTabs.displayName = 'ExternalInvitationTabs';

export default ExternalInvitationTabs;
